import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getModuleData } from '../../../selectors/modules';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { Props } from './Tiers';

type StateProps = Pick<Props, 'tiers'>;
type DispatchProps = Pick<Props, never>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const { tiers: tiersIds = [] } = getModuleData(state, ownProps.moduleId);
  const tiers = getDeviationsByIds(state, tiersIds);
  return {
    tiers,
  };
};

export default connect(mapStateToProps);
